// frontend/src/components/common/Select.jsx
// COMPONENTE SELECT REUTILIZABLE
import React, { useMemo } from 'react';
import styled from 'styled-components';
import SearchableSelectField from './SearchableSelectField';

// CONTAINER DEL CAMPO
const FieldContainer = styled.div`
  margin-bottom: ${({ $noMargin }) => ($noMargin ? '0' : '1rem')};
`;

// LABEL DEL CAMPO
const Label = styled.label`
  display: block;
  margin-bottom: 0.25rem;
  color: ${({ theme }) => theme.colors.txtPrincipal};
  font-weight: ${({ theme }) => theme.typography.fontWeight.medium};
  font-size: 0.875rem;
`;

// MENSAJE DE ERROR
const ErrorMessage = styled.span`
  display: block;
  margin-top: 0.25rem;
  color: ${({ theme }) => theme.colors.danger};
  font-size: 0.75rem;
`;

// COMPONENTE SELECT
const Select = ({ 
  label, 
  error, 
  options = [], 
  children,
  className,
  noMargin,
  size,
  value,
  onChange,
  name,
  id,
  disabled,
  placeholder,
  ...props 
}) => {
  const normalizedOptions = useMemo(() => {
    if (Array.isArray(options) && options.length > 0) {
      return options.map((option, index) => ({
        id: option?.value ?? option?.id ?? String(index),
        label: option?.label ?? option?.text ?? option?.nombre ?? option?.name ?? String(option?.value ?? ''),
        search: option?.search ?? option?.label ?? option?.text ?? option?.nombre ?? option?.name ?? String(option?.value ?? ''),
        raw: option,
      }));
    }

    return React.Children.toArray(children)
      .filter((child) => React.isValidElement(child) && child.type === 'option')
      .map((child, index) => ({
        id: child.props.value ?? String(index),
        label: typeof child.props.children === 'string' ? child.props.children : String(child.props.children ?? ''),
        search: typeof child.props.children === 'string' ? child.props.children : String(child.props.children ?? ''),
        disabled: Boolean(child.props.disabled),
      }));
  }, [children, options]);

  const selectableOptions = normalizedOptions.filter((option) => !option.disabled && String(option.id ?? '') !== '');

  const searchableField = (
    <SearchableSelectField
      className={className}
      options={selectableOptions}
      value={value}
      onChange={(nextValue) => {
        if (typeof onChange === 'function') {
          onChange({ target: { value: nextValue, name, id } });
        }
      }}
      getOptionValue={(option) => String(option.id)}
      getOptionLabel={(option) => option.label || ''}
      getOptionSearch={(option) => option.search || option.label || ''}
      placeholder={placeholder || (label ? `Buscar ${typeof label === 'string' ? label.toLowerCase() : 'opcion'}...` : 'Buscar...')}
      disabled={disabled}
      size={size || 'md'}
      showAllOnFocus
      invalid={Boolean(error)}
      {...props}
    />
  );

  // Si no hay label, no renderizar el FieldContainer que agrega margen y limita el flex
  if (!label) {
    return searchableField;
  }

  return (
    <FieldContainer $noMargin={noMargin}>
      {label && <Label>{label}</Label>}
      {searchableField}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </FieldContainer>
  );
};

export default Select;
